import { render, staticRenderFns } from "./BankAccountCrud.vue?vue&type=template&id=6be2001a"
import script from "./BankAccountCrud.vue?vue&type=script&lang=js"
export * from "./BankAccountCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports